import { render, staticRenderFns } from "./QRDownload.vue?vue&type=template&id=33c49ad7&"
import script from "./QRDownload.vue?vue&type=script&lang=js&"
export * from "./QRDownload.vue?vue&type=script&lang=js&"
import style0 from "./QRDownload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports